export var LegacyFrames;
(function (LegacyFrames) {
    LegacyFrames["AppleWatch"] = "apple-watch-42-frame";
    LegacyFrames["AppleWatch38"] = "apple-watch-38-frame";
    LegacyFrames["IPad"] = "ipad-frame";
    LegacyFrames["IPadPro11"] = "ipad-pro-11-frame";
    LegacyFrames["IPhone4"] = "iPhone4";
    LegacyFrames["IPhone4S"] = "iphone4s-frame";
    LegacyFrames["IPhone5"] = "iphone5-frame";
    LegacyFrames["IPhone5C"] = "iphone5c-frame";
    LegacyFrames["IPhone6"] = "iphone6-frame";
    LegacyFrames["IPhone6Plus"] = "iphone6plus-frame";
    LegacyFrames["IPhoneX"] = "iphonex-frame";
    LegacyFrames["Pixel4"] = "pixel4-frame";
    LegacyFrames["Lumia920"] = "lumia920-frame";
    LegacyFrames["S5"] = "s5-frame";
    LegacyFrames["Nexus5"] = "nexus5-frame";
    LegacyFrames["Htc1"] = "htc-one-frame";
    LegacyFrames["DesktopWeb"] = "desktop-view";
    LegacyFrames["Web"] = "web-frame";
})(LegacyFrames || (LegacyFrames = {}));
